'use client';

import { Suspense } from 'react';
import { OrcamentoView } from '@/components/orcamento/OrcamentoView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function BudgetPage() {
  useChatPage('budget');
  return (
    <div data-onboarding-budget-page>
      {/* The Categorias directory is date-insensitive — always the current month. */}
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <OrcamentoView />
      </Suspense>
    </div>
  );
}
